import { Component, Input, OnInit } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import {RxComponent} from '../../../../../../core/components/common/rx.component';

@Component({
    selector: 'itpx-certificate-name-form',
    templateUrl: './certificate-name-form.component.html',
    styleUrls: ['./certificate-name-form.component.css']
})
export class CertificateNameFormComponent extends RxComponent implements OnInit {
    @Input() data: any;
    initialValue: string;

    constructor(private modalService: SmartModalService) {
        super()
    }

    ngOnInit() {
        this.initialValue = this.data.form.get('name').value;
    }

    get isTouched() {
        return this.data.form.get('name').value !== this.initialValue;
    }

    onCancel() {
        this.data.form.patchValue({ name: this.initialValue })
        this.modalService.close();
    }

    onSubmit() {
        this.modalService.sendResult(this.data.form.get('name').value)
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/components/details/certificate-name-form/certificate-name-form.component.ts